import { render, staticRenderFns } from "./TreeNode.vue?vue&type=template&id=4d6f678a&scoped=true"
import script from "./TreeNode.vue?vue&type=script&lang=js"
export * from "./TreeNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6f678a",
  null
  
)

export default component.exports